// import React from 'react';

// const AboutUs = () => {
//   return (
//     <div className="bg-gray-100 min-h-screen p-8 flex items-center justify-center">

//       <div className="w-1/2">
//         <h1 className="text-4xl font-bold  mb-4 text-left">About Us</h1>
//         <p className="text-xl text-gray-700 text-left mb-8">
//           Learn more about our company and our mission.
//         </p>
//         <p className="text-lg text-gray-800 mb-4">
//           Welcome to Divine Trans Logistic! We are dedicated to providing top-quality logistics and transportation services. With years of experience in the industry, we ensure that your goods are transported safely, reliably, and on time. Our team of professionals is committed to maintaining the highest standards in every aspect of our business.
//         </p>
//         <p className="text-lg text-gray-800 mb-4">
//           Our mission is to simplify logistics for businesses by offering customized solutions that meet their unique requirements. We believe in building strong relationships with our clients and partners, focusing on trust, integrity, and customer satisfaction.
//         </p>
//         <p className="text-lg text-gray-800">
//           Whether you are looking for trucking services, trailer rentals, or specialized transportation, we have the expertise and resources to handle all your needs. Feel free to reach out to us to learn more about how we can assist you.
//         </p>
//       </div>
//       <div className="w-1/2 flex justify-center">
//         <img 
//           src="/divinelogo.jpg" 
//           alt="About Us"
//           className="rounded-lg shadow-lg max-w-lg h-auto"
//         />
//       </div>
//     </div>
//   );
// };

// export default AboutUs;


import React from "react";

const AboutUs = () => {
  return (
    <section className="bg-white">
      
      {/* TOP INTRO */}
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-14">
        <h1 className="text-4xl md:text-5xl font-semibold text-gray-900">
          About Divine Trans Logistic
        </h1>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl">
          Building reliable, efficient, and transparent logistics solutions for businesses across India.
        </p>
      </div>

      {/* MAIN CONTENT */}
      <div className="bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">

          {/* TEXT */}
          <div>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Welcome to <span className="font-medium text-gray-900">Divine Trans Logistic</span>. 
              We specialize in providing dependable logistics and transportation services designed
              to meet modern business demands. With years of industry experience, we ensure that
              every shipment is handled with care, efficiency, and precision.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Our team works closely with clients to deliver customized logistics solutions,
              whether it’s truck booking, trailer services, or specialized transportation.
              We focus on long-term partnerships built on trust, transparency, and consistent performance.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed">
              At Divine Trans Logistic, our goal is simple — to move your goods safely, reliably,
              and on time, every time.
            </p>
          </div>

          {/* IMAGE */}
          <div className="flex justify-center">
            <img
              src="/divinelogo.jpg"
              alt="Divine Trans Logistic"
              className="rounded-xl shadow-md max-w-md w-full"
            />
          </div>
        </div>
      </div>

      {/* MISSION / VALUES */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          <div className="bg-gray-50 p-8 rounded-xl">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To simplify logistics by delivering reliable, scalable, and customized
              transportation solutions for businesses of all sizes.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Our Vision
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To become a trusted logistics partner recognized for operational excellence,
              transparency, and customer satisfaction.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Our Values
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Integrity, reliability, and commitment to delivering value in every shipment
              we manage.
            </p>
          </div>

        </div>
      </div>

    </section>
  );
};

export default AboutUs;
